import {Auth} from '.';

export default class Guard {
  private AUTH = new Auth();

  public verifyError(response: any) {
    if (response.status === 401) {
      this.AUTH.LogOut();
    }
  }
}
